import styled from '@emotion/styled';
import { Avatar as AvatarBase } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { useDisplayNameFormatter } from 'components/DisplayNameFormatter/useDisplayNameFormatter';
import { getCustomerById } from 'selectors/customerSelectors';

import * as Utils from '../../chat/dashboard/components/Conversations/components/Item/utils';

const Avatar = styled(AvatarBase)`
  flex-shrink: 0;
  font-weight: bold;
  text-transform: uppercase;
  position: relative;
  border: solid 1px #FFF;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &.phone,
  &.mail {
    font-size: 16px;
    display: flex !important;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 991px){
      display: none !important;
    }
  }
`;

export const ProfilePicture = ({ customer, ...avatarProps }) => {
  const { profilePicPath } = customer ?? {};
  const displayNameFormatter = useDisplayNameFormatter();
  const abbr = Utils.getCustomerAbbreviation(customer, displayNameFormatter);
  const AvatarIcon = !abbr && Utils.getAvatarIcon({ customer });
  const className = !abbr && Utils.getAvatarClassName({ customer });

  return (
    <Avatar
      icon={AvatarIcon}
      src={profilePicPath}
      {...avatarProps}
      className={classNames(className, avatarProps.className)}
    >
      {abbr}
    </Avatar>
  );
};

const ProfilePictureWrapper = ({ id = '', selector = getCustomerById, ...avatarProps }) => {
  const customer = useSelector(state => selector(state, id));
  return <ProfilePicture customer={customer} {...avatarProps} />;
};

export default ProfilePictureWrapper;
